import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'

class Laridae {
  static getUltimaVersion () {
    const axios = getAxiosInstance()
    const promise = axios.get(`ultima_version_laridae`)
    return promise.then(lrsAdapter, lrsAdapter)
      .then((result) => { return result.data[0] })
  }
}

export default Laridae
